// Sample items the generated post appearance previews render: winning
// tickets in both flavours and one two-selection card per generated origin.
import { PERSONA_CREATOR_DEFAULT_NAME } from '../../config/brandingTokens'
import { normalizeFeedPreviewItem } from '../../utils/feedPreviewItem'

const PREVIEW_CREATED_AT = '2026-09-21T12:00:00Z'

// Feed payloads carry both odds formats, so the previews do too.
const PREVIEW_LEGS = [
  ['OKC Thunder -7.5', 'Spread - 1st Half', { decimal: 1.91, american: '-110' }],
  ['Nikola Jokic Over 11.5', 'Rebounds', { decimal: 1.87, american: '-115' }],
  ['Anthony Edwards Over 26.5', 'Points', { decimal: 1.95, american: '-105' }],
]
const PREVIEW_COMBINED_ODDS = { decimal: 6.9648, american: '+596' }

function previewTicket(id, cta) {
  const selections = PREVIEW_LEGS.map(([label, market, odds], index) => ({
    id: `${id}-leg-${index}`,
    sort_order: index,
    label,
    market: { name: market },
    odds,
    settlement_status: 'won',
  }))
  return {
    id,
    kind: 'post',
    text: '',
    title: '3-leg winner',
    created_at: PREVIEW_CREATED_AT,
    content_origin: 'winning_ticket',
    creator: { id: 'winning-tickets-persona', display_name: 'WinningTickets' },
    media: [],
    tags: [],
    cta,
    share_enabled: true,
    selection_set: {
      schema_version: '1.0',
      source: {},
      summary: { kind: 'provider_defined', label: 'parlay', selection_count: selections.length, odds: PREVIEW_COMBINED_ODDS },
      selections,
      groups: [],
      entries: [],
    },
  }
}

export const CREATOR_TICKET_PREVIEW = previewTicket('preview-creator-ticket', {
  kind: 'follow_creator',
  label: 'Follow @JustABetOutside',
  target: 'preview-creator',
  target_name: 'Just A Bet Outside',
})
export const SELECTIONS_TICKET_PREVIEW = previewTicket('preview-selections-ticket', null)

// Both generated origins publish under the org's seeded persona creator. The
// personalized-bets status does not expose its name, so the preview uses the
// seeded default; with no avatar the card shows its initial, and a Persona
// name / avatar token overrides both as it does in the feed.
const PERSONA_CREATOR = Object.freeze({ id: 'preview-persona-creator', display_name: PERSONA_CREATOR_DEFAULT_NAME })

// A two-selection post of the given origin, in the shape FeedCard renders.
function generatedPostPreview(id, contentOrigin, { title, text, legs }) {
  return normalizeFeedPreviewItem({
    id,
    kind: 'post',
    title,
    text,
    created_at: PREVIEW_CREATED_AT,
    content_origin: contentOrigin,
    creator: { ...PERSONA_CREATOR },
    share_enabled: true,
    // Shows the bet button its CTA tokens style, as the Surfaces showcase does.
    cta: { kind: 'url', label: 'Add to betslip', target: 'https://example.com/bet' },
    legs: legs.map(([label, market, event, odds, outcomeId]) => ({
      label,
      market_name: market,
      event_name: event,
      odds,
      selection: { outcome_id: outcomeId },
    })),
  })
}

export const GENERATED_PREVIEWS = Object.freeze({
  'crowd-recommendation': generatedPostPreview('preview-crowd-recommendation', 'personalized_recommendation', {
    title: 'The crowd is backing Kansas City',
    text: 'Most bettors on this game are on these two.',
    legs: [
      ['Kansas City Chiefs', 'Moneyline', 'Chiefs @ Bills', { decimal: 1.8, american: '-125' }, 1001],
      ['Travis Kelce Over 64.5', 'Receiving Yards', 'Chiefs @ Bills', { decimal: 1.87, american: '-115' }, 1002],
    ],
  }),
  'personalized-ticket': generatedPostPreview('preview-personalized-ticket', 'personalized_ticket', {
    title: 'Lakers and Suns double',
    text: 'A ticket placed on this feed.',
    legs: [
      ['Los Angeles Lakers', 'Moneyline', 'Lakers @ Warriors', { decimal: 2.1, american: '+110' }, 2001],
      ['Phoenix Suns -3.5', 'Spread', 'Suns @ Nuggets', { decimal: 1.91, american: '-110' }, 2002],
    ],
  }),
})
